var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccess2 = function SvgSuccess2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 74c18.778 0 34-15.222 34-34S58.778 6 40 6 6 21.222 6 40s15.222 34 34 34Z",
    fill: "#2F5EA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m33.907 54.43-12.35-12.639a1.977 1.977 0 0 1 0-2.75l2.686-2.75a1.87 1.87 0 0 1 2.687 0l8.32 8.515L53.07 26.57a1.87 1.87 0 0 1 2.687 0l2.687 2.75c.741.759.741 1.99 0 2.75l-21.85 22.36a1.87 1.87 0 0 1-2.688 0Z",
    fill: "#fff"
  })));
};
export default SvgSuccess2;